var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-content',[_c('cHeader'),_c('div',{staticClass:"default-pad"},[_c('p',[_vm._v(_vm._s(_vm.$t("Thank")))])]),_c('cFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }